export default __webpack_public_path__ + "static/media/ppTaxStatementSample2022.ddc079e7.png";